import React from 'react';
import { observer } from 'mobx-react';
import styles from './ThoughtProcess.module.scss';

interface ThoughtStep {
  type: 'thinking' | 'tool_start' | 'tool_complete' | 'crafting_response' | 'error_step' | 'thought';
  content: string;
  timestamp: string;
}

interface ThoughtProcessProps {
  steps: ThoughtStep[];
}

const ThoughtProcess: React.FC<ThoughtProcessProps> = ({ steps }) => {
  const [isExpanded, setIsExpanded] = React.useState(true);

  if (steps.length === 0) return null;

  const formatStepContent = (content: string, type: string) => {
    // Select emoji based on event type
    let emoji = '⚙️'; // default
    if (type === 'thinking') {
      emoji = '🤔';
    } else if (type === 'tool_start') {
      emoji = '⚙️';
    } else if (type === 'tool_complete') {
      emoji = '✅';
    } else if (type === 'crafting_response') {
      emoji = '✍️';
    } else if (type === 'error_step') {
      emoji = '⚠️';
    }

    // Split on first colon to separate action from details
    const colonIndex = content.indexOf(':');
    if (colonIndex > -1) {
      const action = content.substring(0, colonIndex);
      const details = content.substring(colonIndex + 1).trim();

      return (
        <>
          <div className={styles.stepAction}>
            <span className={styles.emoji}>{emoji}</span>
            <strong>{action}</strong>
          </div>
          {details && <div className={styles.stepDetails}>{details}</div>}
        </>
      );
    }

    return (
      <div className={styles.stepAction}>
        <span className={styles.emoji}>{emoji}</span>
        <strong>{content}</strong>
      </div>
    );
  };

  return (
    <div className={styles.thoughtContainer}>
      <div
        className={styles.thoughtHeader}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span>
          <span className={styles.arrow}>{isExpanded ? '▾' : '▸'}</span>
          Thought Process
        </span>
        <span className={styles.stepCount}>{steps.length} steps</span>
      </div>

      {isExpanded && (
        <div className={styles.thoughtSteps}>
          {steps.map((step, idx) => (
            <div
              key={idx}
              className={styles.thoughtStep}
              data-type={step.type}
            >
              {formatStepContent(step.content, step.type)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default observer(ThoughtProcess);
